export default "__VITE_ASSET__DnDngOa8__"